import React, { Component } from "react";
import moment from "moment";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import Redux from "../common/Redux";
import { SubscriptionPlanSCreen } from "../screens/SubscriptionScreens";
import routes from "./URL";

class HotelRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Switch>
        {/* <Route
                    path={routes.admin.hotels.create}
                    component={SubscriptionPlanSCreen}
                /> */}
        <Route path={routes.root} component={SubscriptionPlanSCreen} />

        {/* <Route exact path={"/"} component={ListGalleryScreen} /> */}
      </Switch>
    );
  }
}

export default Redux(HotelRoutes);
